// @flow
import { createAction } from 'redux-actions';

export const initializeAction = createAction('V2_INITIALIZE');
export const finalizeAction = createAction('V2_FINALIZE');
